import { useEffect, useRef } from 'react';

// Declare PayPal types in the global namespace
declare global {
  interface Window {
    PayPal?: {
      Donation: {
        Button: (options: {
          env: string;
          hosted_button_id: string;
          image: {
            src: string;
            alt: string;
            title: string;
          };
        }) => {
          render: (selector: string) => void;
        };
      };
    };
  }
}

const PayPalButton = () => {
  const paypalRef = useRef<HTMLDivElement>(null);
  const buttonRendered = useRef<boolean>(false);

  useEffect(() => {
    // Only run this once
    if (buttonRendered.current) return;

    // Check if PayPal is already loaded
    if (window.PayPal) {
      renderButton();
      return;
    }

    // Load the script only if it's not already in the DOM
    if (!document.querySelector('script[src="https://www.paypalobjects.com/donate/sdk/donate-sdk.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.paypalobjects.com/donate/sdk/donate-sdk.js';
      script.charset = 'UTF-8';
      script.async = true;
      
      script.onload = () => {
        renderButton();
      };

      document.body.appendChild(script);
    } else if (window.PayPal) {
      // Script is already loaded, just render the button
      renderButton();
    }

    return () => {
      // Clean up the button container
      if (paypalRef.current) {
        paypalRef.current.innerHTML = '';
      }
    };
  }, []);

  const renderButton = () => {
    if (window.PayPal && !buttonRendered.current && paypalRef.current) {
      buttonRendered.current = true;
      
      // Clear any existing content
      paypalRef.current.innerHTML = '';
      
      // Create the container structure PayPal expects
      const container = document.createElement('div');
      container.id = 'donate-button-container';
      
      const buttonDiv = document.createElement('div');
      buttonDiv.id = 'donate-button';
      
      container.appendChild(buttonDiv);
      paypalRef.current.appendChild(container);

      // Render the button
      window.PayPal.Donation.Button({
        env: 'production',
        hosted_button_id: 'C3PWMVTYXZ2LE',
        image: {
          src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif',
          alt: 'Donate with PayPal button',
          title: 'PayPal - The safer, easier way to pay online!',
        }
      }).render('#donate-button');
    }
  };

  return <div ref={paypalRef} />;
};

export default PayPalButton;